import Customer from "../../types/customer";
import ProfileBox from "./profile-box";
import NavbarBrand from "../tailwind/navbar-brand";
import AuthContext from "../auth-context";
import { useContext } from "react";
import MenuItems from "./menu-items";

export interface SidebarProps {
  customer: Customer;
  isCollapsed: boolean;
  isVisible: boolean;
  onCollapse: (isCollapsed: boolean) => void;
  onShow: (isVisible: boolean) => void;
}

function Sidebar({
  customer,
  isCollapsed,
  isVisible,
  onCollapse,
  onShow,
}: SidebarProps) {
  const context = useContext(AuthContext);
  const { serviceType } = context;

  return (
    <div
      id="sidebar"
      className={`sidebar sidebar-fixed sidebar-backdrop expandable sidebar-lightpurple2 sidebar-spaced ${
        isCollapsed ? "collapsed" : ""
      } ${isVisible ? "sidebar-visible" : ""}`}
      onClick={(e) => {
        const { id } = e.target as HTMLTextAreaElement;
        if (id === "sidebar") onShow(false);
      }}
    >
      <div className="sidebar-inner">
        <div className="d-xl-flex sidebar-section-item m-0 fadeable-left fadeable-top">
          <div className="fadeinable">
            <div
              className="py-2 mx-1 border-b-1 brc-secondary-l2"
              id="sidebar-header-brand1"
            >
              <NavbarBrand className="text-140 text-dark-tp3">
                <img
                  className="logo collapsed brc-primary-tp2"
                  src="https://c.sepanta.com/i1/Logos/SepantaLogo.png"
                  style={{ height: "35px" }}
                  alt="logo"
                />
              </NavbarBrand>
            </div>
          </div>
          <div className="fadeable w-100">
            <div
              className="py-2 text-center mx-3 border-b-1 brc-secondary-l2"
              id="sidebar-header-brand2"
            >
              <NavbarBrand className="sidebar-logo ml-n2 text-140 text-dark-tp3">
                <img
                  className="logo expanded brc-primary-tp2"
                  src="https://c.sepanta.com/i1/Logos/SepantaLogo.png"
                  style={{ height: "35px" }}
                  alt="logo"
                />
                <span className="mainTitle">سپنتا</span>
              </NavbarBrand>
            </div>
          </div>
        </div>

        <div className="pt-2 flex-grow-1 ace-scroll" data-ace-scroll="{}">
          <ProfileBox
            customer={customer}
            onShow={onShow}
            onCollapse={onCollapse}
          />
          <MenuItems
            medium={serviceType}
            onShow={onShow}
            onCollapse={onCollapse}
          />
        </div>

        <div className="sidebar-section">
          <div className="sidebar-section-item fadeable-left fadeable-top">
            <div className="fadeinable"></div>
            <div
              id="sidebar-footer"
              className="fadeable text-center border-t-1 w-95 sidebar-lightblue brc-secondary-l1"
            >
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
